export const about = [
  {
    title: "Quem é a Kenzie Academy? Quando ela foi fundada?",
    paragraph:
      "Somos uma escola de programação web, com sede nos EUA e metodologia do Vale do Silício para formação de desenvolvedores Full Stack em até 12 meses, com mais de 90% dos alunos empregados em até seis meses após a formatura. O curso conta com horário de estudo flexível, suporte em tempo real, e além da programação, ensinamos também metodologia ágil e soft skills, além de uma forte preparação para entrevistas e um núcleo dedicado de empregabilidade. Hoje, a Kenzie é considerada a escola que mais emprega no Brasil, e conta com mais de 500 empresas parceiras que já contrataram nossos alunos.",
  },
  {
    title: "Qual a duração do curso de programação da Kenzie?",
    paragraph:
      "O curso tem acesso por 1 ano, podendo ser renovado, e o aluno que decide o seu ritmo de aprendizado. Porém, em média, a conclusão de todos os módulos acontece em até 12 meses, sendo metade do curso voltado para formação Front End e metade para formação Back End.",
  },
  {
    title: "A Kenzie Academy vale a pena?",
    paragraph:
      "Sim. Na Kenzie, você tem a oportunidade de começar uma carreira em tecnologia, a área mais promissora do mercado, que oferece boa remuneração e oportunidades. Temos centenas de alunos que já passaram por nossa instituição.",
  },
  {
    title: "O curso da Kenzie é técnico?",
    paragraph:
      "Não. Trata-se de curso livre, com acesso por 1 ano ao conteúdo e focado em programação, mas que ensina também metodologia ágil e soft skills. E nos módulos finais do curso, os alunos têm a possibilidade de serem contratados pelas nossas mais de 500 empresas parceiras.",
  },
  {
    title: "Ganho um certificado?",
    paragraph:
      "Sim. Nossa formação conta com certificado de curso livre que comprova o conhecimento “Full Stack” em programação.",
  },
  {
    title: "Quais os requisitos para ser aluno Kenzie?",
    paragraph:
      "Acreditamos que toda pessoa pode aprender a programar! Por isso, para ser aluno ou aluna da Kenzie basta você ter em casa um computador com alguns requisitos mínimos e internet para acessar as aulas e atividades!",
  },
];

export const course = [
  {
    title: "Como funciona o curso?",
    paragraph:
      "A Kenzie oferece as habilidades técnicas com as principais linguagens e tecnologias do mercado e as soft skills para o desenvolvimento de uma pessoa programadora Full Stack (Front End e Back End). Nossas aulas são online e contam com total apoio de instrutores e monitores. Suporte em tempo real! Nosso conteúdo é 100% prático e atualizado trimestralmente de acordo com as mais atuais linguagens e tendências da programação.",
  },
  {
    title: "Programador(a) em apenas um ano? Duvido!",
    paragraph:
      "É verdade sim, pode acreditar! :) A Kenzie começou em 2017, nos Estados Unidos, com o propósito de oferecer a oportunidade para pessoas se formarem e ingressarem no mercado de tecnologia rapidamente, com mensalidades acessíveis e ensino de alta qualidade. Já formamos centenas de alunos e somos considerados a escola que mais emprega no Brasil!",
  },
  {
    title: "Aprenderei sobre soft skills?",
    paragraph:
      "Sim, você aprenderá e estará em constante aprendizado para desenvolver suas soft skills diariamente. Contamos com um time de sucesso do aluno, direcionado para ajudar você nesse quesito em específico.",
  },
  {
    title: "No curso vou aprender a fazer apps?",
    paragraph:
      "Não. Nosso foco é em desenvolvimento web. Sem dúvida, várias habilidades aprendidas na Kenzie podem ser levadas para outros tipos de desenvolvimento, mas todas as linguagens são voltadas para web.",
  },
  {
    title: "Preciso ter conhecimento na área para participar do curso?",
    paragraph: "Não é necessário nenhum conhecimento prévio em programação.",
  },
  {
    title: "Preciso saber inglês?",
    paragraph:
      "Não exigimos um segundo idioma. Todos os materiais usados durante o curso são em português ou traduzidos.",
  },
];

export const payment = [];

export const laborMarket = [
  {
    title: "Vocês me ajudam a conseguir um emprego?",
    paragraph:
      "Contamos com uma rede de mais de 500 parceiros para ajudar na sua rápida contratação e colocação no mercado de trabalho. Esse parceiros são empresas e startups de diferentes tamanhos, segmentos e localizadas pelo Brasil inteiro. Além disso, daremos todo o suporte, através do nosso time, para você se preparar para os testes (hard skills) e entrevistas (soft skills).",
  },
  {
    title: "Após o curso, tenho um emprego garantido?",
    paragraph:
      "Não. Vamos nos esforçar muito e estar com você durante essa jornada. Mas não podemos garantir emprego. Daremos todo o apoio que você precisar, vamos abrir portas com parceiros, mas o sucesso depende também do seu esforço e comprometimento.",
  },
];
